import { useEffect } from 'react';

import { useIsMobileApp } from './useIsMobileApp';

export const useDisableMobileAppZoom = () => {
  const isMobileApp = useIsMobileApp();

  useEffect(() => {
    if (!isMobileApp) {
      return;
    }

    const viewport = document.querySelector('meta[name="viewport"]');
    const originalContent = viewport?.getAttribute('content');
    const noZoomContent = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no';

    if (viewport) {
      viewport.setAttribute('content', noZoomContent);
    }

    return () => {
      if (viewport && originalContent) {
        viewport.setAttribute('content', originalContent);
      }
    };
  }, [isMobileApp]);
};
